import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
import {
  getUsersAPI,
} from 'api';
import { TextField } from '@material-ui/core';


const CustomUsersAutocomplete = ({setUserEmail}) => {
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const { usersEmailAutocomplete } = useSelector((state) => state.admin);

  const usersEmail = usersEmailAutocomplete.map((user) => user.email);

  useEffect(() => {
    if (searchValue) {
      const params = new URLSearchParams({
        email: searchValue,
        page: '1',
        limit: '10',
      }).toString();

      getUsersAPI({dispatch, params, autocomplete: true});
    }
  }, [
    searchValue
  ]);

  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={usersEmail}
      getOptionLabel={(option) => option}
      onInputChange={(e, value) => {
        setSearchValue(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          onBlur={(e) => setUserEmail(e.target.value)}
          label={
            <div className="flex items-center">
              User Email
            </div>
          }
          InputProps={{ ...params.InputProps, type: 'search' }}
        />
      )}
    />
  );
};

export default CustomUsersAutocomplete;
